import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import AuthLayout from "./layout/AuthLayout/authLayout";
import AuthLayout1 from "./layout/AuthLayout/authLayout1";
import Layout from "./layout/appLayout";
import ProfileSelection from "./pages/preAuth/profile-selection";
import SecurityQuestions from "./pages/preAuth/security-questions";
import CASADetails from "./pages/accounts/components/casaDetails";
import MiniStatement from "./pages/accounts/components/casa/mini-statement";
import ShowAccountBalances from "./pages/accounts/components/casa/showBalances";
import DepositDetails from "./pages/accounts/components/deposits/depositDetails";
import ForcePassword from "./pages/preAuth/force-password";
import DetailedStatement from "./pages/accounts/components/casa/detailed-statement";
import AuthLayoutStatic from "./pages/preAuth/authWrapperStatic";
import PayeeTransfer from "./pages/send-money/payee-transfer";
import LoanDetails from "./pages/accounts/components/loan/loanDetails";
import LoanStatement from "./pages/accounts/components/loan/loan-statement";
import OpenDeposit from "./pages/accounts/components/deposits/open-deposit";
import ChequeDetails from "./pages/cheques/cheque-details";
import MyChequeDetails from "./pages/cheques/my-cheques";
import TransferLimitDetails from "./pages/accounts/components/transferLimitDetails";
import DepositStatement from "./pages/accounts/components/deposits/deposit-statement";
import ChangePassword from "./pages/change-password/change-password";
import OwnAccountTransfer from "./pages/send-money/own-account-transfer";
import ModifyPaymentScheduledTrnsComponent from "./pages/send-money/schedule-payee-modify";
import QuickPayment from "./pages/send-money/quick-transfer/quick-transfer";
import ExchangeRates from "./pages/newDesign/exchange-rates";
import LoanDepoistCalculator from "./pages/newDesign/loan-depositer-calculator";
import AddAccount from "./pages/accounts/components/casa/add-account";
import ModifyInternalPayee from "./pages/beneficiary/internal/modify-internal-payee";
import ModifyDomesticPayee from "./pages/beneficiary/other/modify-domestic-payee";
import ModifyInternationalPayee from "./pages/beneficiary/international/modify-international-payee";
import InternalPayeeDetails from "./pages/beneficiary/internal/internal-payee-details";
import DomesticPayeeDetails from "./pages/beneficiary/other/domestic-payee-details";
import InternationalPayeeDetails from "./pages/beneficiary/international/international-payee-details";
import TermsAndConditions from "./pages/preAuth/termAndConditions";
import CallUs from "./pages/preAuth/callUs";
import PendingBillerBeneficiary from "./pages/pending-authorization/components/billerBene";
import HistoryBiller from "./pages/history/components/biller";
import ContactUs from "./pages/help/help";
// import ForgotUserName from "./pages/preAuth/forgot-username";
import BulkUpload from "./pages/bulk-upload/bulk-upload";
import PendingBulkUpload from "./pages/pending-authorization/components/bulk-upload";
import HistoryBulkPaymentUpload from "./pages/history/components/bulk-payment-upload";
import HistoryGovernment from "./pages/history/components/gepeg";
import RegisterNow from "./pages/newDesign/register";
// import { ForgotPassword } from "./pages/preAuth/forgot-password";
import Deposits from "./pages/deposits/deposits";
import Loans from "./pages/loans/loans";
import ExchangeRateComponent from "./pages/exchangeRates/excahngeRates";
import Transfer from "./pages/send-money/transfer";
import BeneficiaryManagement from "./pages/beneficiary/beneficiary-management";
import Payment from "./pages/pay-bills/payments";
import { FailToLogin } from "./pages/newDesign/loginFail";
import AllTransactionHistory from "./pages/transaction-history/transaction-history";
import ScheduledPaymentsComponent from "./pages/pay-bills/scheduled-payments";
import RepaymentTransfer from "./pages/repayment-transfer/repayment-transfer";
import AddWalletPayee from "./pages/beneficiary/wallet/add-wallet-payee";
import WalletPayeeDetails from "./pages/beneficiary/wallet/wallet-payee-details";
import ModifyWalletPayee from "./pages/beneficiary/wallet/modify-wallet-payee";
import InternalQuickTransfer from "./pages/send-money/quick-transfer/internal-transfer";
import DomesticQuickTransfer from "./pages/send-money/quick-transfer/domestic-transfer";
import InternationalQuickTransfer from "./pages/send-money/quick-transfer/international-transfer";
import WalletQuickTransfer from "./pages/send-money/quick-transfer/wallet-transfer";
import QrCodeComponent from "./pages/settings/qrCode";
import TermsAndConditionComponent from "./pages/settings/termsAndConditions";
import Request from "./pages/settings/request/request";
import DebitCard from "./pages/settings/request/debitCard/debitCard";
import PendingDebitCard from "./pages/pending-authorization/components/debitcard";
import HistoryDebitCard from "./pages/history/components/debitCard";
import GovernmentPaymentHistory from "./pages/government-payments/government-payments-history";
import ChequeBookRequest from "./pages/settings/request/chequeBook/cheque-book-request";
import PendingChequeBookCard from "./pages/pending-authorization/components/cheueBookRequest";
import HistoryChequeBookRequestCard from "./pages/history/components/chequeBookRequest";
import DisbursementInquiry from "./pages/accounts/components/loan/disbursment-inquiry";
import ScheduleInquiry from "./pages/accounts/components/loan/schedule-inquiry";
import Repayment from "./pages/accounts/components/loan/repayment";
import PendingLoanRepayment from "./pages/pending-authorization/components/loan-repayment";
import HistoryLoanRepaymentCard from "./pages/history/components/loan-repayment";
import Cheques from "./pages/cheques/cheques";
import HistoryStopChequeCard from "./pages/history/components/stopCheque";
import PendingStopChequeCard from "./pages/pending-authorization/components/stopCheque";
import EStamentRequest from "./pages/settings/estatement";
import EStamentRequestCasa from "./pages/accounts/components/casa/estatement-request";
import AboutUs from "./pages/settings/aboutUs";
import PendingDeposits from "./pages/pending-authorization/components/deposits";
import HistoryDeposits from "./pages/history/components/deposits";
import ProtectedLayout from "./pages/preAuth/protectedLayout";
import PasswordLayout from "./pages/preAuth/paswordlayout";
import HistoryLuku from "./pages/history/components/luku";
import HistoryBeneUpload from "./pages/history/components/beneUpload";
import HistoryBankToWallet from "./pages/history/components/bankToWallet";
import HistoryLoanRequest from "./pages/history/components/loan-request";
import HistoryDebitCardStatus from "./pages/history/components/debitCardStatus";
import HistoryBlockDebitCard from "./pages/history/components/blockDebitCard";
import PendingBeneUpload from "./pages/pending-authorization/components/beneUpload";
import PendingBankToWallet from "./pages/pending-authorization/components/bankToWallet";
import PendingDebitCardStatus from "./pages/pending-authorization/components/debitCardStatus";
import PendingLoanRequest from "./pages/pending-authorization/components/loan-request";
import PendingLuku from "./pages/pending-authorization/components/luku";
import PendingBlockDebitCard from "./pages/pending-authorization/components/blockDebitCard";
import RequestDebitCard from "./pages/card-settings/new-debit-card";
import SalaryAdvance from "./pages/salary-advance/salary-advance";
import SalaryAdvanceRequest from "./pages/salary-advance/salary-advance-request";
import SalaryAdvanceRepay from "./pages/salary-advance/salary-advance-repay";
import PesaLink from "./pages/pesa-link/pesaLink";
import SendToBank from "./pages/pesa-link/send-to-bank";
import SendToPhone from "./pages/pesa-link/send-to-phone";
import PesaDeLinkAccount from "./pages/pesa-link/delink-account";
import PesaLinkAccount from "./pages/pesa-link/link-account";
import PesaLinkBeneficiaryManagement from "./pages/pesa-link/pesaLink-beneficiary";
import AddPesaLinkPayee from "./pages/pesa-link/add-pesaLink-bene";
import PESALINKPayeeDetails from "./pages/pesa-link/pesalink-beneficiary-details";
import ModifyPesaLinkBene from "./pages/pesa-link/modify-pesaLink.bene";
import ManageUserId from "./pages/ManageUserId/ManageUserId";
import ApplyNewLoan from "./pages/accounts/components/loan/apply-loan";
import StopChequeRequest from "./pages/settings/request/stop-cheque/stop-cheque.request";
import ChequeStatus from "./pages/settings/request/chequeStatus/cheque-status";
import Collection from "./pages/trade-finance/collection";
import AboutUS from "./pages/preAuth/about-us";
import SuccessLayout from "./layout/AuthLayout/successLayout";
import ForceChangeOTP from "./pages/preAuth/forcechange-otp";
import HelpSupport from "./pages/newDesign/help-support";
import ExchangeRatesFeature from "./pages/newDesign/exchange-rates-feature";
import ExchangeRateFeatureComponent from "./pages/exchangeRates/exchangeRates-feature";
import OwnQuickTransfer from "./pages/send-money/quick-transfer/own-acc-transfer";

const LandingComponent = React.lazy(() => import("./pages/preAuth/landing"));

const LoginComponent = React.lazy(() => import("./pages/preAuth/login"));
const ForgotUserName = React.lazy(() =>
  import("./pages/preAuth/forgot-username")
);
const ForgotPassword = React.lazy(() =>
  import("./pages/preAuth/forgot-password")
);
const SelfUnlock = React.lazy(() => import("./pages/preAuth/selfUnlock"));
const LoginOTP = React.lazy(() => import("./pages/preAuth/login-otp"));
const ForgotPasswordChange = React.lazy(() =>
  import("./pages/preAuth/forgotpassword-change")
);
const ForgotPasswordOTP = React.lazy(() =>
  import("./pages/preAuth/forgotpassword-otp")
);
const SelfUnlockOTP = React.lazy(() =>
  import("./pages/preAuth/selfunlock-otp")
);
const ForgotUserNameOTP = React.lazy(() =>
  import("./pages/preAuth/forgotusername-otp")
);

const ForgotPasswordMain = React.lazy(() =>
  import("./pages/preAuth/forgot-password-main")
);
const ForgotUserNameMain = React.lazy(() =>
  import("./pages/preAuth/forgotusername-main")
);
const SelfUnlockMain = React.lazy(() =>
  import("./pages/preAuth/self-unlock-main")
);

const DashboardComponent = React.lazy(() =>
  import("./pages/dashboard/dashboard")
);

const MyAccountsComponent = React.lazy(() =>
  import("./pages/accounts/accounts")
);

const PortfolioComponent = React.lazy(() =>
  import("./pages/portfolio/portfolio")
);

const SendMoneyComponent = React.lazy(() =>
  import("./pages/send-money/send-money")
);

const PaymentHistoryComponent = React.lazy(() =>
  import("./pages/send-money/history/payment-history")
);

const TransactionHistoryComponent = React.lazy(() =>
  import("./pages/send-money/history/transaction-history")
);

const PayBillsComponent = React.lazy(() =>
  import("./pages/pay-bills/pay-bills")
);
const AddBillerComponent = React.lazy(() =>
  import("./pages/pay-bills/add-biller")
);
const ViewBillerComponent = React.lazy(() =>
  import("./pages/pay-bills/view-biller")
);
const CategoryBillerComponent = React.lazy(() =>
  import("./pages/pay-bills/category-biller")
);
const BillPayComponent = React.lazy(() =>
  import("./pages/pay-bills/bill-payment")
);
const MyChequesComponent = React.lazy(() => import("./pages/cheques/cheques"));
const ServiceRequestComponent = React.lazy(() =>
  import("./pages/service-request/service-request")
);

const NewChequeBookComponent = React.lazy(() =>
  import("./pages/cheques/new-cheque-book")
);

const DebitCardNewComponent = React.lazy(() =>
  import("./pages/card-settings/new-debit-card")
);

const DebitCardAddOnComponent = React.lazy(() =>
  import("./pages/card-settings/add-on-card")
);

const DebitCardLimitsComponent = React.lazy(() =>
  import("./pages/card-settings/card-limits")
);

const PayTaxesComponent = React.lazy(() =>
  import("./pages/pay-taxes/pay-taxes")
);
const CardSettingsComponent = React.lazy(() =>
  import("./pages/card-settings/card-settings")
);
const SettingsComponent = React.lazy(() => import("./pages/settings/settings"));
const KYCUpdateComponent = React.lazy(() =>
  import("./pages/kyc-update/kyc-update")
);
const KYCNewComponent = React.lazy(() =>
  import("./pages/kyc-update/kyc-create")
);

const ProfileComponent = React.lazy(() => import("./pages/profile/profile"));

const TransferLimitComponent = React.lazy(() =>
  import("./pages/settings/transferLimit")
);
const SecurityComponent = React.lazy(() =>
  import("./pages/settings/securityQuestions")
);
const PrimaryAccountComponent = React.lazy(() =>
  import("./pages/settings/primaryAccountSelection")
);
const DeRegisterComponent = React.lazy(() =>
  import("./pages/settings/deRegister")
);
const BlockAccountComponent = React.lazy(() =>
  import("./pages/settings/blockAccount")
);

const SMSTxnLimitComponent = React.lazy(() =>
  import("./pages/settings/sms-txn-limit")
);

const MyActivityComponent = React.lazy(() =>
  import("./pages/dashboard/components/my-activity/my-activity")
);

const FAQComponent = React.lazy(() => import("./pages/preAuth/faq"));
const LocateUsComponent = React.lazy(() =>
  import("./pages/newDesign/locate-us")
);

const DeLinkComponent = React.lazy(() =>
  import("./pages/settings/deLinkAccount")
);

const LinkComponent = React.lazy(() => import("./pages/settings/linkAccount"));

const OffersComponent = React.lazy(() => import("./pages/settings/offers"));

const AddBeneficaryComponent = React.lazy(() =>
  import("./pages/beneficiary/add-beneficary")
);

const BulkPaymentComponent = React.lazy(() =>
  import("./pages/bulk-payment/bulk-payment")
);

const SalaryUploadComponent = React.lazy(() =>
  import("./pages/salary-upload/salary-upload")
);

const ScheduledTransactionsComponent = React.lazy(() =>
  import("./pages/send-money/history/scheduled-trans")
);

const PendingAuthComponent = React.lazy(() =>
  import("./pages/pending-authorization/pending-authorization")
);

const PendingGEPGComponent = React.lazy(() =>
  import("./pages/pending-authorization/components/gepg")
);

const PendingTransfers = React.lazy(() =>
  import("./pages/pending-authorization/components/ft")
);
const PendingBeneficiaries = React.lazy(() =>
  import("./pages/pending-authorization/components/beneficiaries")
);

const PendingSalaryUpload = React.lazy(() =>
  import("./pages/pending-authorization/components/salary-upload")
);

const PendingPayments = React.lazy(() =>
  import("./pages/pending-authorization/components/payments")
);

const HistoryComponent = React.lazy(() => import("./pages/history/history"));

const HistoryBeneficiaries = React.lazy(() =>
  import("./pages/history/components/beneficiary")
);

const HistoryTransfers = React.lazy(() =>
  import("./pages/history/components/ft")
);

const HistorySalaryUpload = React.lazy(() =>
  import("./pages/history/components/salary-upload")
);

const HistoryPayments = React.lazy(() =>
  import("./pages/history/components/payments")
);

const StandingInstructionListComponent = React.lazy(() =>
  import("./pages/accounts/components/standing-instruction-list")
);

const StandingInstructionDetailsComponent = React.lazy(() =>
  import(
    "./pages/accounts/components/standing-instructions/standing-instruction-details"
  )
);

const GovermentPaymentComponent = React.lazy(() =>
  import("./pages/government-payments/government-payments")
);

const SalaryUploadHistoryComponent = React.lazy(() =>
  import("./pages/salary-upload/upload-history")
);

const BulkPaymentUploadHistoryComponent = React.lazy(() =>
  import("./pages/bulk-upload/bulk-upload-history")
);

const AddInternalBeneficaryComponent = React.lazy(() =>
  import("./pages/beneficiary/internal/add-internal-payee")
);

const AddOtherBeneficaryComponent = React.lazy(() =>
  import("./pages/beneficiary/other/add-domestic-payee")
);

const AddInternationalBeneficaryComponent = React.lazy(() =>
  import("./pages/beneficiary/international/add-international-payee")
);

const EMICalculatorComponent = React.lazy(() =>
  import("./pages/settings/emi-calculator")
);

const BranchComponent = React.lazy(() => import("./pages/settings/locate-us"));

const FaqComponent = React.lazy(() => import("./pages/settings/faq"));

const TradeFinanceComponent = React.lazy(() =>
  import("./pages/trade-finance/trade-finance")
);

const CollectionComponent = React.lazy(() =>
  import("./pages/trade-finance/collection")
);
const LetterofCreditComponent = React.lazy(() =>
  import("./pages/trade-finance/letter-of-credit")
);

const CreateStandingInstruction = React.lazy(() =>
  import(
    "./pages/accounts/components/standing-instructions/create-standing-instruction"
  )
);

const StandingInstructionCancelComponent = React.lazy(() =>
  import(
    "./pages/accounts/components/standing-instructions/standing-instructions-cancel"
  )
);
const HistorySI = React.lazy(() =>
  import("./pages/history/components/standing-instructions")
);

const CardlessCashList = React.lazy(() =>
  import("./pages/accounts/components/cardLess-cash/token-list")
);

const GenerateToken = React.lazy(() =>
  import("./pages/accounts/components/cardLess-cash/generate-token")
);
const HistoryCardlessCash = React.lazy(() =>
  import("./pages/history/components/cardless-cash")
);

const PendingSI = React.lazy(() =>
  import("./pages/pending-authorization/components/standing-instructions")
);

const PendingCardlessCash = React.lazy(() =>
  import("./pages/pending-authorization/components/cardless-cash")
);

const ViewTokenDetails = React.lazy(() =>
  import("./pages/accounts/components/cardLess-cash/view-token-details")
);

const CancelTokenDetails = React.lazy(() =>
  import("./pages/accounts/components/cardLess-cash/cancel-token-details")
);

const CardManagement = React.lazy(() =>
  import("./pages/card-management/card-management")
);

const BlockDebitCard = React.lazy(() =>
  import("./pages/card-settings/block-debit-card")
);

const MobileToBank = React.lazy(() =>
  import("./pages/pay-bills/mobile-to-bank")
);
const StatementAnalyzer = React.lazy(() =>
  import("./pages/portfolio/statement-analyzer")
);
export default function AppRouter() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />
        {/* <Route
          path="/landing"
          element={
            <AuthLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <LandingComponent />
              </Suspense>
            </AuthLayout>
          }
        /> */}
        <Route
          path="/choose-profile"
          element={
            <AuthLayout1>
              <ProfileSelection />
            </AuthLayout1>
          }
        />
        <Route
          path="/security-questions"
          element={
            <ProtectedLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <SecurityQuestions />
              </Suspense>
            </ProtectedLayout>
          }
        />

        <Route
          path="/force-password"
          element={
            <ProtectedLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <ForcePassword />
              </Suspense>
            </ProtectedLayout>
          }
        />

        <Route
          path="/forcechange-otp"
          element={
            <PasswordLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <ForceChangeOTP />
              </Suspense>
            </PasswordLayout>
          }
        />

        <Route
          path="/callUs"
          element={
            <AuthLayout>
              <CallUs />
            </AuthLayout>
          }
        />

        <Route path="/login-forgot" element={<FailToLogin />} />

        <Route
          path="/login"
          element={
            <AuthLayout module="login" title="Internet Banking Log in">
              <Suspense fallback={<p>Loading..</p>}>
                <LoginComponent />
              </Suspense>
            </AuthLayout>
          }
        />

        <Route path="/forgot-password" element={<ForgotPasswordMain />} />
        <Route path="/forgot-password" element={<ForgotUserNameMain />} />
        <Route path="/forgot-password" element={<SelfUnlockMain />} />
        <Route
          path="/login-otp"
          element={
            <ProtectedLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <LoginOTP />
              </Suspense>
            </ProtectedLayout>
          }
        />
        {/* <Route
          path="/forgot-username"
          element={
            <AuthLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <ForgotUserName />
              </Suspense>
            </AuthLayout>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <AuthLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <ForgotPassword />
              </Suspense>
            </AuthLayout>
          }
        />
        <Route
          path="/self-unlock"
          element={
            <AuthLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <SelfUnlock />
              </Suspense>
            </AuthLayout>
          }
        />

        

        <Route
          path="/forgotpassword-change"
          element={
            <PasswordLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <ForgotPasswordChange />
              </Suspense>
            </PasswordLayout>
          }
        />

        <Route
          path="/forgotpassword-otp"
          element={
            <ProtectedLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <ForgotPasswordOTP />
              </Suspense>
            </ProtectedLayout>
          }
        />

        <Route
          path="/selfunlock-otp"
          element={
            <ProtectedLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <SelfUnlockOTP />
              </Suspense>
            </ProtectedLayout>
          }
        />
         <Route
          path="/forgotusername-otp"
          element={
            <ProtectedLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <ForgotUserNameOTP />
              </Suspense>
            </ProtectedLayout>
          }
        /> */}

        <Route
          path="/faq"
          element={
            <AuthLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <FAQComponent />
              </Suspense>
            </AuthLayout>
          }
        />

        <Route
          path="/locations"
          element={
            <AuthLayout1 title="Locate Us">
              <Suspense fallback={<p>Loading..</p>}>
                <LocateUsComponent />
              </Suspense>
            </AuthLayout1>
          }
        />

        <Route
          path="/myActivity"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <MyActivityComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/dashboard"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <DashboardComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/portfolio"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PortfolioComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/accounts"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <MyAccountsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/deposits"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <Deposits />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/loans"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <Loans />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/exchange-rate"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ExchangeRateComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/accounts/summary"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <CASADetails />
              {/* </Suspense> */}
            </Layout>
          }
        />
        <Route
          path="/accounts/summary/balances"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ShowAccountBalances />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/statement"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <MiniStatement />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/statement/detailed"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <DetailedStatement />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/deposit/summary"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <DepositDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/deposit/statement"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <DepositStatement />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/deposit/open"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <OpenDeposit />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/loan/summary"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <LoanDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/loan/statement"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <LoanStatement />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/accounts/transfer-limit"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <TransferLimitDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/send-money"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SendMoneyComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/bill-payment/history"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PaymentHistoryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/send-money/history"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <TransactionHistoryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/send-money/history/scheduled/modify"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ModifyPaymentScheduledTrnsComponent />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/internal-beneficiary-modify"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ModifyInternalPayee />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/domestic-beneficiary-modify"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ModifyDomesticPayee />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/wallet-beneficiary-modify"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ModifyWalletPayee />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/international-beneficiary-modify"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ModifyInternationalPayee />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/internal-beneficiary-details"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <InternalPayeeDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/domestic-beneficiary-details"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <DomesticPayeeDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/wallet-beneficiary-details"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <WalletPayeeDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/international-beneficiary-details"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <InternationalPayeeDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/transfer"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <Transfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/send-money/manage-beneficiary"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <BeneficiaryManagement />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/send-money/payee-transfer"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <PayeeTransfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/send-money/quick-pay"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <QuickPayment />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/internal-quick-transfer"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <InternalQuickTransfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/other-quick-transfer"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <DomesticQuickTransfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/international-quick-transfer"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <InternationalQuickTransfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/wallet-quick-transfer"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <WalletQuickTransfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/send-money/payee-transfer/own"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <OwnAccountTransfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/payment"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <Payment />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/bill-payment"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PayBillsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/mobile-money"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PayBillsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/bill-payment/add-biller"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddBillerComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/bill-payment/view-biller"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ViewBillerComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/bill-payment/billers"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <CategoryBillerComponent />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/bill-payment/biller/billpay"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BillPayComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/mobile-money/biller/billpay"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BillPayComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/cheques"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <MyChequesComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/cheques/status"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ChequeDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/cheques/details"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <MyChequeDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/service-request"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ServiceRequestComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/service-request/new-cheque-book"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <NewChequeBookComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/card-settings/new"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <DebitCardNewComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/card-settings/add-on"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <DebitCardAddOnComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/card-settings/block-debit-card"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BlockDebitCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/card-settings/debit-card/limits"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <DebitCardLimitsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pay-taxes"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PayTaxesComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/card-settings"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <CardSettingsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SettingsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/kyc-update"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <KYCUpdateComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/kyc-update/new"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <KYCNewComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/transfer-limit"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <TransferLimitComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/security"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SecurityComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/primaryAcc"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PrimaryAccountComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/deRegister"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <DeRegisterComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/blockAccount"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BlockAccountComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/smsTxnLimit"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SMSTxnLimitComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/profile"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ProfileComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/change-password"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ChangePassword />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/manage-userId"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ManageUserId />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/exchange-rates"
          element={
            <AuthLayout1 title="Exchange Rates">
              <ExchangeRates />
            </AuthLayout1>
          }
        />

        <Route
          path="/loan-eligibility"
          element={
            <AuthLayout1 title="Eligibility">
              <LoanDepoistCalculator />
            </AuthLayout1>
          }
        />

        <Route
          path="/add-account"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddAccount />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <AuthLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <TermsAndConditions />
              </Suspense>
            </AuthLayout>
          }
        />

        <Route
          path="/settings/delink-account"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <DeLinkComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/link-account"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <LinkComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/offers"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <OffersComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/add-beneficary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddBeneficaryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/bulk-payment"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BulkPaymentComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/salary-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SalaryUploadComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingAuthComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/ft"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingTransfers />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/stop-cheque"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingStopChequeCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/gepg"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingGEPGComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/beneficiary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingBeneficiaries />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/salary-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingSalaryUpload />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/bulk-payment-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingBulkUpload />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/payments"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingPayments />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/biller-bene"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingBillerBeneficiary />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/debit-card"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingDebitCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/cheque-book"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingChequeBookCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/bene-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingBeneUpload />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/bank-to-wallet"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingBankToWallet />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/debit-card-status"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingDebitCardStatus />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/loan-request"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingLoanRequest />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/luku"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingLuku />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/block-debit-card"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingBlockDebitCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/biller-bene"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryBiller />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/payments"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryPayments />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/ft"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryTransfers />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/salary-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistorySalaryUpload />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/bulk-payment-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryBulkPaymentUpload />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/beneficiary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryBeneficiaries />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/gepg"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryGovernment />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/debit-card"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryDebitCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/cheque-book"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryChequeBookRequestCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/block-debit-card"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryBlockDebitCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/send-money/scheduled"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ScheduledTransactionsComponent />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/help"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ContactUs />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/standing-instruction"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <StandingInstructionListComponent />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/standing-instruction/view"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <StandingInstructionDetailsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/government-payment"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <GovermentPaymentComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/bulk-payment-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BulkUpload />
              </Suspense>
            </Layout>
          }
        />

        {/* <Route
          path="/forgot-username"
          element={
            <AuthLayout>
              <ForgotUserName />
            </AuthLayout>
          }
        /> */}

        <Route
          path="/salary-upload/history"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SalaryUploadHistoryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route path="/register" element={<RegisterNow />} />

        <Route
          path="/bulk-payment-upload/history"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BulkPaymentUploadHistoryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/add-internal-beneficary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddInternalBeneficaryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/add-other-beneficary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddOtherBeneficaryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/add-international-beneficary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddInternationalBeneficaryComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/add-wallet-beneficary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddWalletPayee />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/trans-history"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AllTransactionHistory />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/scheduled-payments"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ScheduledPaymentsComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/re-payment"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <RepaymentTransfer />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/emi-calculator"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <EMICalculatorComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/locate-us"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <BranchComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/faq"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <FaqComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/about-us"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AboutUs />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/qr-code"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <QrCodeComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/settings/terms-and-conditions"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <TermsAndConditionComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/request"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <Request />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/request/cheque-status"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ChequeStatus />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/request/stop-cheque"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <StopChequeRequest />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/request/debit-card"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <DebitCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/debit-card-request"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <RequestDebitCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/government-payment/history"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <GovernmentPaymentHistory />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/request/cheque-book/request-cheque"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ChequeBookRequest />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/accounts/loan/disbursement-inquiry"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <DisbursementInquiry />
              {/* </Suspense> */}
            </Layout>
          }
        />
        <Route
          path="/accounts/loan/schedule-inquiry"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ScheduleInquiry />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/trade-finance"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <TradeFinanceComponent />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/trade-finance/collection"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <CollectionComponent />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/trade-finance/letter-of-credit"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <LetterofCreditComponent />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/create-standing-instruction"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <CreateStandingInstruction />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/accounts/loan/repayment"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <Repayment />
              {/* </Suspense> */}
            </Layout>
          }
        />
        <Route
          path="/pending-authorization/loan-repayment"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingLoanRepayment />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/loan-repayment"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryLoanRepaymentCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/stop-cheque"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryStopChequeCard />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/accounts/loan/apply"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ApplyNewLoan />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/my-cheques"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <Cheques />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/request/eStatement"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <EStamentRequest />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/accounts/statement/eStatement"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <EStamentRequestCasa />
              {/* </Suspense> */}
            </Layout>
          }
        />
        <Route
          path="/pending-authorization/standing-instructions"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingSI />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/standing-instruction/cancel"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <StandingInstructionCancelComponent />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/history/si"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistorySI />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/cardless-cash"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <CardlessCashList />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/generate-token"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <GenerateToken />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/cardless-cash"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryCardlessCash />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/cardless-cash"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingCardlessCash />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/token-details/view"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ViewTokenDetails />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/token-details/cancel"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <CancelTokenDetails />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pending-authorization/deposits"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PendingDeposits />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/Deposits"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryDeposits />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/card-management"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <CardManagement />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/luku"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryLuku />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/bene-upload"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryBeneUpload />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/loan-request"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryLoanRequest />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/bank-to-wallet"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryBankToWallet />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/history/debit-card-status"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <HistoryDebitCardStatus />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/salaray-advance"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SalaryAdvance />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/salaray-advance-request"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SalaryAdvanceRequest />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/salaray-advance-repay"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SalaryAdvanceRepay />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/pesaLink"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PesaLink />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pesaLink/send-to-bank"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SendToBank />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pesaLink/send-to-phone"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <SendToPhone />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pesaLink/link-account"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PesaLinkAccount />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/pesaLink/delink-account"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <PesaDeLinkAccount />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/pesaLink/manage-beneficiary"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <PesaLinkBeneficiaryManagement />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/add-pesaLink-beneficary"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <AddPesaLinkPayee />
              </Suspense>
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/pesaLink-beneficiary-modify"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <ModifyPesaLinkBene />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/beneficiary-management/PesaLink-beneficiary-details"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <PESALINKPayeeDetails />
              {/* </Suspense> */}
            </Layout>
          }
        />
        <Route
          path="/bill-payment/billers/send-to-bank"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <MobileToBank />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/statement-analyzer"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <StatementAnalyzer />
              </Suspense>
            </Layout>
          }
        />
        <Route
          path="/about-us"
          element={
            <AuthLayout>
              <Suspense fallback={<p>Loading..</p>}>
                <AboutUS />
              </Suspense>
            </AuthLayout>
          }
        />
        <Route
          path="/success"
          element={
            <Suspense fallback={<p>Loading..</p>}>
              <SuccessLayout />
            </Suspense>
          }
        />
        <Route
          path="/help-support"
          element={
            <AuthLayout1 title="Help & Support">
              <HelpSupport />
            </AuthLayout1>
          }
        />

        <Route
          path="/own-quick-transfer"
          element={
            <Layout>
              {/* <Suspense fallback={<p>Loading..</p>}> */}
              <OwnQuickTransfer />
              {/* </Suspense> */}
            </Layout>
          }
        />

        <Route
          path="/exchange-rates-feature"
          element={
            <AuthLayout1 title="Exchange Rates">
              <ExchangeRatesFeature />
            </AuthLayout1>
          }
        />

        <Route
          path="/exchange-rate-feature"
          element={
            <Layout>
              <Suspense fallback={<p>Loading..</p>}>
                <ExchangeRateFeatureComponent />
              </Suspense>
            </Layout>
          }
        />
      </Routes>
    </>
  );
}
